var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.serverName))]),_c('div',{staticClass:"icon"},[_c('ExpandIcon',{attrs:{"size":28}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }